import { IOrderTransaction } from "redux/reducers/models/order";

export function isHouseAccountTransaction(transaction: IOrderTransaction): boolean {
  const method = transaction.payment_method?.toLowerCase() ?? "";
  const type = transaction.payment_type?.toLowerCase().replace(/_/g, " ") ?? "";

  return method === "account" || type === "account";
}

export function orderHasActiveHouseAccountPayments(
  transactions?: IOrderTransaction[] | null,
): boolean {
  if (!transactions?.length) {
    return false;
  }

  return transactions.some(
    transaction =>
      isHouseAccountTransaction(transaction) &&
      transaction.account_id != null &&
      !transaction.voided_at,
  );
}
